angular.module('bb.util').directive('infiniteScroll', InfiniteScroll);

InfiniteScroll.$inject = ['$parse'];

function InfiniteScroll($parse) {
  function link(scope, elm, attr) {
    const raw = elm[0];
    elm.css({ 'overflow-y': 'auto' });
    elm.bind('scroll', function () {
      if (
        raw.scrollTop + raw.offsetHeight >= raw.scrollHeight &&
        !$parse(attr.loadMore)(scope)
      ) {
        scope.$apply(attr.infiniteScroll);
      }
    });
  }
  return {
    restrict: 'A',
    link,
  };
}

export {};
